import * as Pages from "../../pages";
import { BulkOrder } from "../../components";

export const PageModule = { ...Pages, BulkOrder };
